/** Referral contest rules — client first-visit modal + public rules page. */

export const CONTEST_RULES_VERSION = "2026-07-v1";

export const CONTEST_RULES_SECTIONS = [
  {
    title: "Overview",
    paragraphs: [
      "The referral contest is run once per eligible country (one edition only). Refer traders on Path 1 (broker partner). The top 5 qualified referrers in your country win subscription prizes via unique promo codes.",
    ],
  },
  {
    title: "Country eligibility",
    paragraphs: [
      "A country opens its contest when it reaches at least 50 clients with an active paid Path 1 subscription and a verified broker partner account (snapshot on the 1st of the month, 00:05 UTC).",
      "If your country is below 50 at snapshot, there is no contest that month. It may open the month it first reaches 50.",
    ],
  },
  {
    title: "Who can participate",
    paragraphs: [
      "Referrer: active AlphaSniper account, Path 1, verified broker partner, active paid subscription, one natural person = one account.",
      "Referred client: registers via your link (https://alphasniper.io/SignUp?ref=YourClientID) during the active contest period. Their country does not matter.",
      "A validated referral = broker partner verified + active paid subscription on Path 1. No self-referrals.",
    ],
  },
  {
    title: "Prizes & minimum referrals",
    paragraphs: [
      "1st — Alpha subscription offered (45 validated referrals minimum)",
      "2nd — Beta subscription offered (30 minimum)",
      "3rd — Gama subscription offered (20 minimum)",
      "4th & 5th — Delta subscription offered (10 minimum each)",
      "You must reach both the rank and the minimum referrals to win. Prizes are delivered as one-time promo codes on Path 1 only (WLCMBP). Codes expire 60 days after notification.",
    ],
  },
  {
    title: "Leaderboard & overtime",
    paragraphs: [
      "1 validated referral = 1 point. Rankings are per country until final closure.",
      "If #1 and #2 are tied below 45 referrals at month end, overtime may extend the contest up to 14 days for the same edition.",
      "AlphaSniper may reject fraudulent referrals and disqualify participants. Decisions are final except for manifest errors.",
    ],
  },
];
